import React from 'react';
import { useQuery } from 'react-query';
import { MeInfoContext } from 'contexts/MeInfoContext';
import { getMe } from 'apis';
import { MeInfo } from 'interfaces/auth';
import { setMyStores, setAdminMeInfo, setAdminMode } from 'utils/storages';

export const useMeInfo = () => React.useContext(MeInfoContext);

export const onSuccessMe = (data: MeInfo) => {
  try {
    const { admin, storeList } = data;

    /*
    시현 코드 추가
    */
    setAdminMode(true);
    setAdminMeInfo(admin);
    if (storeList && storeList.length) {
      setMyStores(storeList, admin.id);
    }
  } catch (error) {
    console.error(error);
  }
};

export const useGetMe = (enabled: boolean) => {
  const { changeMeInfo } = useMeInfo();
  const onSuccess = (data: MeInfo) => {
    onSuccessMe(data);
    changeMeInfo(data);
  };
  return useQuery<MeInfo>(['getMe'], () => getMe(), { enabled, onSuccess });
};
